import { useState, useEffect } from 'react'
import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, ToasterTexts, } from "../shared/constants";
import CustomSwitch from '../shared/switch.component';
import { SettingsModel } from '../../models/settings-model';
import { SettingsService } from '../../services/SettingsService';
import { UpdateSettings, LoadSettings } from '../../actions';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import SettingsHeader from './settingsHeader.component';
import { AppRoutes } from '../routes/route.path';
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'

interface Props {
}

const Signature = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Settings: SettingsModel = useSelector(selector.settingsObj)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [signAll, setSignAll] = useState<boolean>(Settings ? Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true" : false);
    const [signError, setSignError] = useState<string>("");
    const [signature, setSignature] = useState(Settings ? Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString() : "");
    const [enableAction, setEnableActions] = useState<boolean>(false)

    useEffect(() => {
        refreshSignature();
    }, [])

    useEffect(() => {
        if (Settings?.Settings?.find(x => x.Name)?.Name !== Settings?.Settings?.find(x => x.Name)?.Name) {
            refreshSignature();
        }
    }, [])

    const refreshSignature = () => {
        let sign = Settings ? Settings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString() : "";
        setSignature(sign)
        setSignAll(signAll)
    }

    const formSubmit = async (e: any) => {
        e.preventDefault();
        if (!signError) {
            setIsLoading(true)
            let settingSign = Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE)
            let settingSignAll = Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES);
            let promises = [];
            if (settingSign) {
                promises.push(
                    UpdateSettings(dispatch, {
                        id: settingSign?.ID,
                        name: settingSign?.Name,
                        code: settingSign?.Code,
                        value: signature,
                    })
                );
            }

            if (settingSignAll) {
                promises.push(
                    UpdateSettings(dispatch, {
                        id: settingSignAll?.ID,
                        name: settingSignAll?.Name,
                        code: settingSignAll?.Code,
                        value: signAll.toString(),
                    })
                );
            }
            await Promise.all(promises);
            await LoadSettings(dispatch);
            setToast(ToasterTexts.CUSTOM_SIGNATURE, ToasterType.SUCCESS);
            setEnableActions(false);
            setIsLoading(false);
        }
        else {
            setIsLoading(false)
        }
    }

    const handleCloseEditSignature = (e) => {
        let signature = Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString() ?? "";
        setSignature(signature)
        setSignAll(Settings.Settings.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true")
        setEnableActions(false)

        if (signature?.length > 100) {
            setSignError("Custom Signature should not exceed 100 characters")
        }
        else if (!signature.trim() || signature.trim().length <= 0) {
            setSignError("Custom Signature cannot be blank")
        }
        else {
            setSignError("")
        }
    };

    const handleSwitch = (checked: boolean) => {
        setSignAll(checked);
        setEnableActions(true);
    }

    const handleChange = (e: any) => {
        setSignature(e.target.value)
        setEnableActions(true);
        if (e.target.value.length > 100) {
            setSignError("Custom Signature should not exceed 100 characters")
        }
        else if (!e.target.value.trim() || e.target.value.trim().length <= 0) {
            setSignError("Custom Signature cannot be blank")
        }
        else {
            setSignError("")
        }
    };
    return (
        <>
            <div className={`m-auto`}>
                <div className={`d-flex justify-between w-p-100  ${IsMobileDevice ? "" : "mt-2"}`}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Custom Signature"} subTitle={appNote.AUTOMATICALLY_APPEND_SIGNATURE} />
                    <div className={`d-flex align-center ${IsMobileDevice ? "bg-color-secondary bb-primary-divider-4" : ""}`}>
                        <CustomSwitch
                            checked={signAll}
                            onChange={handleSwitch}
                        />
                    </div>
                </div>
                <div className={`${IsMobileDevice ? "" : "my-1 bb-primary-divider-4"}`}></div>
                <div className={`${IsMobileDevice ? 'py-3 px-3' : ''} `}>
                    {!!IsMobileDevice && <div className="h5-regular my-2">{appNote.AUTOMATICALLY_APPEND_SIGNATURE}</div>}
                    <div className="my-2">
                        <form onSubmit={formSubmit}>
                            <TextField
                                autoFocus
                                placeholder="Custom Signature "
                                label="Custom Signature"
                                variant="outlined"
                                size="small"
                                name="Custom Signature"
                                fullWidth
                                value={signature}
                                className="br-1 w-fill"
                                onChange={(e) => { handleChange(e); setEnableActions(true) }}
                            />
                            <FormHelperText className="h5 color-primary-danger ml-auto">
                                {signError}
                            </FormHelperText>
                        </form>
                    </div>
                    <div>
                        <Grid container>
                            <Grid item xs={12} className={`d-flex mt-2 ${IsMobileDevice ? '' : 'justify-flex-end'}`} >
                                <ButtonComponent
                                    Variant={!enableAction ? "disabled-btn-small" : "secondary-btn-small"}
                                    ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : ''}`}
                                    OnClick={
                                        handleCloseEditSignature
                                    }
                                    ButtonLabel={buttonLabels.CANCEL}
                                />
                                <ButtonComponent
                                    Variant={!enableAction ? "disabled-btn-small" : "primary-btn-small"}
                                    ClassName={`c-pointer w-space ${IsMobileDevice ? 'w-100' : ''}`}
                                    OnClick={formSubmit}
                                    ButtonLabel={buttonLabels.SAVE}
                                    Loading={isLoading}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Signature;

